
function popupShow(id){
    document.querySelector("#" + id).classList.add('show');
    document.querySelector('body').classList.add('no-overflow');
    document.querySelector('body').classList.add('overlay');
}

function popupHide(){
    document.querySelector('.popup_with-image').classList.remove('show');
    document.querySelector('body').classList.remove('popup-show');
    document.querySelector('.popup-overlay').classList.remove('active');
}

function init(){
    let popupCloseButtons = document.querySelectorAll('.popup_with-image__cross');

    let popUp = document.querySelector('.popup_with-image');
    if(popUp) {
        let popUpOverlay = document.querySelector('.popup-overlay');
        let body = document.querySelector('body');
        let isPopupCookie = document.cookie.split(';').some((item) => item.trim().startsWith('popup=true'));

        if (!isPopupCookie) {
            setTimeout(() => {
                popUp.classList.add('show');
                popUpOverlay.classList.add('active');
                body.classList.add('popup-show');
            }, 10000);
        }


        popupCloseButtons.forEach((button) => {

            button.addEventListener('click', () => {
                let date = new Date();
                date.setDate(date.getDate() + 3);
                document.cookie = "popup=true; path=/; expires=" + date.toUTCString();
                popupHide('popup_with-image');

            });
        });
    }

}

export default {init, popupHide};
